import { createSelector } from '@ngrx/store';

import { UiUserHistorysState, UserHistoryModuleState } from '../state/user-history-module.state';
import { userHistoryRootSelector } from './user-history-root.selector';

export const getUserHistoryState = createSelector(
  userHistoryRootSelector,
  (state: UserHistoryModuleState) => state ? state.ui : {} as UiUserHistorysState
);

